export enum LookupApiUrls {
  GetLookupLocations = "/api/Lookup/GetLookupLocations",
  GetLookupPlans = "/api/Lookup/GetLookupPlans",
  GetLookupMasterPlans = "/api/Lookup/GetLookupPlanContainers",
  GetLookupJobs = "/api/Lookup/GetLookupJobs"
}
